import ScrollReveal from "./ScrollReveal";

const statements: Array<{ text: string; emphasis: boolean }> = [
  {
    text: "Startups don't fail because of bad ideas.",
    emphasis: true,
  },
  {
    text: "They fail because they build before they validate. They ship before they think. They scale before they have signal.",
    emphasis: false,
  },
  {
    text: "I've built companies from zero. Raised millions. Grown to 650,000 users. Been acquired.",
    emphasis: true,
  },
  {
    text: "I've also watched companies burn through runway building the wrong thing.",
    emphasis: false,
  },
  {
    text: "Zero to ten is not about speed. It's about building the right thing, the right way, from day one.",
    emphasis: true,
  },
  {
    text: "AI makes it faster. Security makes it durable. Experience makes it possible.",
    emphasis: true,
  },
];

export default function MyPOV() {
  return (
    <section id="my-pov" aria-label="My Point of View" className="bg-surface">
      <div className="editorial-container section-spacing">
        {/* Label */}
        <ScrollReveal>
          <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
            MY POV
          </p>
        </ScrollReveal>

        {/* Statements */}
        <div className="mt-12 max-w-3xl space-y-10">
          {statements.map((statement, i) => (
            <ScrollReveal
              key={i}
              stagger={Math.min(i + 1, 5) as 1 | 2 | 3 | 4 | 5}
            >
              <p
                className={
                  statement.emphasis
                    ? "font-display text-section font-bold text-foreground md:text-section-md"
                    : "text-body-lg text-foreground-muted md:text-body-lg-md"
                }
              >
                {statement.text}
              </p>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
